import { Injectable } from '@angular/core';
import { ApiHttpClient, ListOption, ListOptionRequest } from '../modules/tcm-core.module';
import { ServiceCodeListOptionRequest } from '../models/service-codes/service-code-list-option-request';

@Injectable({
  providedIn: 'root'
})
export class ServiceCodeDataService {

  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public getServiceCodeOptionsAsync(query: string, timeout: Promise<any>): Promise<ListOption<number>[]> {
    const request: ListOptionRequest = { searchString: query };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('ServiceCodes/Options', request, timeout);
  }

  public getBinauralServiceCodeOptionsAsync(query: string, isBinaural: boolean, timeout: Promise<any>): Promise<ListOption<number>[]> {
    const request: ServiceCodeListOptionRequest = { searchString: query, isBinaural: isBinaural };
    return this.httpClient.getJsonAsync<ListOption<number>[]>('ServiceCodes/GetOptionsByEarType', request, timeout);
  }
}
